import { render, staticRenderFns } from "./forward_messaging.vue?vue&type=template&id=22783eb8&scoped=true"
import script from "./forward_messaging.vue?vue&type=script&lang=js"
export * from "./forward_messaging.vue?vue&type=script&lang=js"
import style0 from "./forward_messaging.vue?vue&type=style&index=0&id=22783eb8&prod&lang=css"
import style1 from "./forward_messaging.vue?vue&type=style&index=1&id=22783eb8&prod&scoped=true&lang=css"
import style2 from "./forward_messaging.vue?vue&type=style&index=2&id=22783eb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22783eb8",
  null
  
)

export default component.exports